import gsap from "gsap";
import Footer from "./components/Layout/Footer";
import Header from "./components/Layout/Header";
import AboutSection from "./components/Sections/About.section";
import Companies from "./components/Sections/Companies.section";
import Contact from "./components/Sections/Contact.section";
import HomeSection from "./components/Sections/Home.section";
import Products from "./components/Sections/Products.section";
import "./styles/tailwind.css";
import "./styles/animations.css";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Gallery from "./components/Sections/Gallery.beta";

gsap.registerPlugin(ScrollTrigger);

function App() {
  return (
    <main className="bg-white font-prompt-regular">
      <Header />
      <HomeSection />
      <Companies />
      <Products />
      <Gallery />
      <AboutSection />
      <Contact />
      <Footer />
    </main>
  );
}

export default App;
